import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NotificationModel } from '../models/notification.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private toastr: ToastrService) {}

  mgsView(notificationModel: NotificationModel) {
    if (notificationModel == undefined) {
      this.toastr.warning('Vuelve a iniciar sesión', 'Sesión expirada');
    } else {
      if (notificationModel.configNotification == null) {
        notificationModel.configNotification = { timeOut: 5000, enableHtml: true };
      }
      switch (notificationModel.type) {
        case 1: {
          this.toastr.success(
            notificationModel.messenger,
            notificationModel.title,
            notificationModel.configNotification
          );
          break;
        }
        case 2: {
          this.toastr.info(notificationModel.messenger, notificationModel.title, notificationModel.configNotification);
          break;
        }
        case 3: {
          this.toastr.error(notificationModel.messenger, notificationModel.title, notificationModel.configNotification);
          break;
        }
        case 4: {
          this.toastr.warning(
            notificationModel.messenger,
            notificationModel.title,
            notificationModel.configNotification
          );
          break;
        }
        case 11: {
          this.toastr.success(
            notificationModel.messenger,
            notificationModel.title,
            notificationModel.configNotification
          );
          break;
        }
      }
    }
  }

  showError(message: string, title?: string): void {
    if (message || title) {
      this.toastr.error(message, title, { disableTimeOut: true, closeButton: true });
    } else {
      console.log('Ingrese un mensaje o un titulo para ejecutar el toast');
    }
  }

  showSuccess(message: string, title?: string): void {
    this.getNotification(1, message, title);
  }

  showWarning(message: string, title?: string): void {
    this.getNotification(4, message, title);
  }

  showInfo(message: string, title?: string): void {
    this.getNotification(2, message, title);
  }

  showSuccessTime(message: string, title?: string, timeOut?: number): void {
    let configNotification = { timeOut: timeOut };
    this.getNotification(11, message, title, configNotification);
  }

  public getNotification(type: number, message: string, title: string, configNotification?: any) {
    let response = new NotificationModel();
    response.type = type;
    response.messenger = message;
    response.title = title;
    response.configNotification = configNotification;

    this.mgsView(response);
  }
}
